export const splitByLineBreak = (text: string): string[] => {
  return text.split(/\r?\n/)
}

export const removeTrailingDecimalsAndZeros = (num: string): number => {
  return Number(num.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, ''))
}

export const capitalizeFirstLetter = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export const decapitalizeFirstLetter = (word: string) =>
  word.charAt(0).toLowerCase() + word.slice(1)

export const splitToArrayOnCapitalLetters = (word: string) => {
  return word.split(/(?=[A-Z])/) || []
}

export const splitToStringOnCapitalLetters = (word: string) => {
  return word.replace(/([A-Z])/g, ' $1').trim() || ''
}

export const splitToArrayOnCommas = (text: string) => {
  return text.split(',').map(part => part.trim())
}

export const urlifyText = (text: string) => {
  return text.toLowerCase().replace(/\s+/g, '-').replaceAll('&', 'and')
}

export const deUrlifyText = (text: string) => {
  const textArray = text
    .replace('/', '')
    .split(/[-\s]/)
    .map(word => capitalizeFirstLetter(word))
  return textArray.join(' ')
}

export const truncateText = (text: string, maxLength: number, suffix = '...'): string => {
  if (text.length <= maxLength) {
    return text
  }
  return text.slice(0, maxLength) + suffix
}

export const trimHTMLFormattedText = (text: string): string =>
  text
    .replaceAll(/&nbsp;?/g, '<br>')
    .replaceAll(/\n/g, '<br>')
    .trim()
